/**
 * Datos sembrados para el modo vista previa en local.
 *
 * No son datos reales: sirven para revisar como se ven las pantallas y los
 * tabs sin depender de Azure AD ni de que Odoo tenga cuentas analiticas
 * cargadas. Respetan las interfaces de core/interfaces/project-api.interface.
 */
import {
  ProjectDetailResponse,
  ProjectsApiItem,
  ProjectsApiResponse
} from '../core/interfaces/project-api.interface';
import {
  ESTADOS_PROYECTO,
  MONEDAS,
  PAISES,
  REGIONES,
  ROLES_RESPONSABLE,
  SOCIEDADES,
  TIPOS_PRODUCTO,
  TIPOS_PROYECTO,
  TIPOS_SERVICIO,
  UNIDADES,
  comoCatalogo,
  comoCatalogoPorId
} from './preview-maestros';

export const PROYECTOS_DEMO: ProjectsApiItem[] = [
  {
    id: 1,
    code: 'PRJ-001',
    name: 'CER',
    project_type: 'Productivo',
    client: 'Vippinn ARG',
    venta_real: 480000,
    ingresos_reales: 297600.0,
    costos_reales: 297600,
    margen_real_porcentual: 0.0,
    estado: 'Planificación',
    unidad_negocio: 'Consultoría',
    tipo_producto: 'Servicios profesionales',
    tipo_servicio: 'Llave en mano',
    empresa: 'Vippinn Argentina',
    description: 'Implementación para Vippinn Argentina — Llave en mano',
    total_selling_price: '480000',
    operating_margin: '182400',
    operating_margin_percentage: '38',
    market_margin_percentage: '20',
    project_health: 1,
    sold_hours: '4200'
  },
  {
    id: 2,
    code: 'PRJ-002',
    name: 'Trackinn',
    project_type: 'Estructura',
    client: 'Vippinn ARG',
    venta_real: 0,
    ingresos_reales: 0.0,
    costos_reales: 0,
    margen_real_porcentual: null,
    estado: 'En Curso',
    unidad_negocio: 'Desarrollo',
    tipo_producto: 'Licencias',
    tipo_servicio: 'Time & Material',
    empresa: 'Vippinn Argentina',
    description: 'Implementación para Vippinn Argentina — Time & Material',
    total_selling_price: '',
    operating_margin: '',
    operating_margin_percentage: '25',
    market_margin_percentage: '',
    project_health: 3,
    sold_hours: '1800'
  },
  {
    id: 3,
    code: 'PRJ-003',
    name: 'Monitor',
    project_type: 'Productivo',
    client: 'Defensoría',
    venta_real: 312000,
    ingresos_reales: 193440.0,
    costos_reales: 215280,
    margen_real_porcentual: -11.29,
    estado: 'En Pausa',
    unidad_negocio: 'Infraestructura',
    tipo_producto: 'Servicios profesionales',
    tipo_servicio: 'Llave en mano',
    empresa: 'Vippinn Chile',
    description: 'Implementación para Vippinn Chile — Llave en mano',
    total_selling_price: '480000',
    operating_margin: '182400',
    operating_margin_percentage: '38',
    market_margin_percentage: '1.5',
    project_health: 3,
    sold_hours: '3600'
  },
  {
    id: 4,
    code: 'PRJ-004',
    name: 'Telesoft',
    project_type: 'Productivo',
    client: 'Bernard S.A.',
    venta_real: 148000,
    ingresos_reales: 91760.0,
    costos_reales: 116920,
    margen_real_porcentual: -27.42,
    estado: 'Replanificación',
    unidad_negocio: 'Consultoría',
    tipo_producto: 'Hardware',
    tipo_servicio: 'Soporte',
    empresa: 'Vippinn Argentina',
    description: 'Implementación para Vippinn Argentina — Soporte',
    total_selling_price: '480000',
    operating_margin: '182400',
    operating_margin_percentage: '38',
    market_margin_percentage: '5',
    project_health: 2,
    sold_hours: '2900'
  },
  {
    id: 5,
    code: 'PRJ-005',
    name: 'Portal Clientes',
    project_type: 'Productivo',
    client: 'Aerobyte SAS',
    venta_real: 925000,
    ingresos_reales: 573500.0,
    costos_reales: 536500,
    margen_real_porcentual: 6.45,
    estado: 'Finalizado',
    unidad_negocio: 'Desarrollo',
    tipo_producto: 'Servicios profesionales',
    tipo_servicio: 'Time & Material',
    empresa: 'Vippinn USA',
    description: 'Implementación para Vippinn USA — Time & Material',
    total_selling_price: '312000',
    operating_margin: '96720',
    operating_margin_percentage: '31',
    market_margin_percentage: '18',
    project_health: 1,
    sold_hours: '2400'
  },
  {
    id: 6,
    code: 'PRJ-006',
    name: 'Migración SAP',
    project_type: 'Productivo',
    client: 'Core Consulting SA',
    venta_real: 660000,
    ingresos_reales: 409200.0,
    costos_reales: 481800,
    margen_real_porcentual: -17.74,
    estado: 'Cerrado',
    unidad_negocio: 'Consultoría',
    tipo_producto: 'Licencias',
    tipo_servicio: 'Llave en mano',
    empresa: 'Vippinn Chile',
    description: 'Implementación para Vippinn Chile — Llave en mano',
    total_selling_price: '925000',
    operating_margin: '388500',
    operating_margin_percentage: '42',
    market_margin_percentage: '27',
    project_health: 1,
    sold_hours: '8100'
  },
  {
    id: 7,
    code: 'PRJ-007',
    name: 'Mantenimiento Odoo',
    project_type: 'Estructura',
    client: 'Vippinn Chile SpA',
    venta_real: 240000,
    ingresos_reales: 148800.0,
    costos_reales: 158400,
    margen_real_porcentual: -6.45,
    estado: 'En Curso',
    unidad_negocio: 'Infraestructura',
    tipo_producto: 'Servicios profesionales',
    tipo_servicio: 'Soporte',
    empresa: 'Vippinn Argentina',
    description: 'Implementación para Vippinn Argentina — Soporte',
    total_selling_price: '148000',
    operating_margin: '31080',
    operating_margin_percentage: '21',
    market_margin_percentage: '12',
    project_health: 2,
    sold_hours: '1200'
  },
  {
    id: 8,
    code: 'PRJ-008',
    name: 'Data Hub',
    project_type: 'Productivo',
    client: 'Vippinn USA LLC',
    venta_real: 515000,
    ingresos_reales: 319300.0,
    costos_reales: 340000,
    margen_real_porcentual: -6.48,
    estado: 'En Curso',
    unidad_negocio: 'Desarrollo',
    tipo_producto: 'Hardware',
    tipo_servicio: 'Time & Material',
    empresa: 'Vippinn USA',
    description: 'Implementación para Vippinn USA — Time & Material',
    total_selling_price: '660000',
    operating_margin: '178200',
    operating_margin_percentage: '27',
    market_margin_percentage: '15',
    project_health: 3,
    sold_hours: '5400'
  }
];

export const RESPUESTA_PROYECTOS: ProjectsApiResponse = {
  success: true,
  user: { id: 1, name: 'Silvina Álvarez', email: 'salvarez@vippinn.com' },
  data: PROYECTOS_DEMO
};

/**
 * Los catalogos del sistema.
 *
 * Sin esto, el forkJoin de ocho llamadas del detalle se caia entero y la
 * pantalla quedaba con los indicadores en '-' y sin nombre de proyecto: se veia
 * como si el proyecto no existiera.
 *
 * Los valores salen de preview-maestros.ts, que es el unico lugar donde vive el
 * relleno de lo que en la vida real llega de ARMUS.
 */
/* Los catálogos no tienen todos la misma forma, y el tipo lo dice en vez de
   esconderlo: los que vienen de Odoo se identifican por `id_odoo`, los que son
   tablas nuestras por `id`, y los roles de responsable llevan además `code` y
   `desde_armus`. Unificarlos obligaría a mentir en alguno. */
type ItemCatalogo =
  | { id_odoo: number; description: string }
  | { id: number; description: string }
  | { id: number; code: string; description: string; desde_armus: boolean };

const CATALOGOS: Record<string, ItemCatalogo[]> = {
  /* `pide_motivo` lo calcula el backend; acá se imita para ver el modal */
  'project/status': comoCatalogo(ESTADOS_PROYECTO).map((e) => ({
    ...e,
    pide_motivo: ['replanificacion', 'cancelado'].includes(e.codigo ?? '')
  })),
  'project/types': comoCatalogo(TIPOS_PROYECTO),
  regions: comoCatalogoPorId(REGIONES),
  companies: comoCatalogoPorId(SOCIEDADES),
  business_units: comoCatalogo(UNIDADES),
  countries: comoCatalogo(PAISES),
  product_types: comoCatalogo(TIPOS_PRODUCTO),
  /* Con la forma real del endpoint, que **no** es la de los otros catálogos:
     `responsible_roles` es una tabla nuestra y su clave es `id`, no `id_odoo`.
     Y trae `desde_armus`, que es lo que decide si el rol se puede elegir a
     mano o lo asigna el ERP. */
  responsibles_roles: [
    { id: 1, code: 'gerente_proyecto', description: 'Gerente de Proyecto', desde_armus: true },
    { id: 2, code: 'responsable_mercado', description: 'Responsable de Mercado', desde_armus: true },
    { id: 3, code: 'service_manager', description: 'Service/Project manager', desde_armus: false }
  ],
  currencies: comoCatalogo(MONEDAS)
};

/** Resuelve /api/system/... y los tipos de servicio, que llevan el id adentro */
export function catalogoDemo(ruta: string): unknown | null {
  const servicios = ruta.match(/\/api\/system\/services_types\/(\d+)$/);
  if (servicios) {
    return { data: comoCatalogo(TIPOS_SERVICIO[Number(servicios[1])] ?? []) };
  }

  /* Los motivos del cambio de estado no son un catálogo de ARMUS: van aparte
     para no ensuciar el tipo de los catálogos. */
  if (/\/api\/system\/project\/motivos-cambio-estado\/?$/.test(ruta)) {
    return {
      data: [
        { estado: 'replanificacion', motivo: 'Cambio de alcance pedido por el cliente' },
        { estado: 'replanificacion', motivo: 'Desvío de horas sobre lo vendido' },
        { estado: 'en_pausa', motivo: 'El cliente frenó el proyecto' },
        { estado: '', motivo: 'Pedido del cliente' }
      ]
    };
  }

  const sistema = ruta.match(/\/api\/system\/(.+?)\/?$/);
  if (!sistema) return null;

  const datos = CATALOGOS[sistema[1]];

  return datos ? { data: datos } : null;
}

/* Cotizaciones de mentira, solo para ver el cambio de moneda en local */
const TC_DEMO: Record<string, number> = { USD: 1, ARS: 1410, EUR: 0.92 };

/* Posterior al periodo por defecto: asi se ve el aviso sin tener que tocar nada */
const FECHA_TC_DEMO = '2026-09-02';

export function detalleProyectoDemo(code: string, moneda?: string | null): ProjectDetailResponse {
  const base = PROYECTOS_DEMO.find((p) => p.code === code) ?? PROYECTOS_DEMO[0];

  const verEn = moneda && TC_DEMO[moneda] ? moneda : 'USD';
  const factor = TC_DEMO[verEn];

  const convertir = (v: string | undefined): string =>
    v ? String(Number(v) * factor) : (v ?? '');

  return {
    id: base.id,
    code: base.code,
    name: base.name,
    description: 'Proyecto de ejemplo cargado por el modo vista previa.',
    sold_hours: base.sold_hours ?? '0',
    project_state: 2,
    project_type: 1,
    business_unit: 10,
    company: 1,
    region: 1,
    product_type: 1,
    service_type: 1,
    public_administration: 0,
    crm_code: 'CRM-2026-001',
    start_date: '2024-12-12',
    end_date: '2026-06-30',
    client: {
      name: base.client,
      country: 1,
      agreement_signed: true,
      /* Uno de ARMUS y uno cargado en Evoluciona. `funcion` es su puesto en la
         empresa —lo dicta ARMUS— y `role` es el rol en **este** proyecto, que
         es de Evoluciona: son dos cosas distintas y antes compartían columna. */
      contacts: [
        { id: 1, origen: 'armus', name: 'Julián Álvarez', email: 'jalvarez@cliente.com', telefono: '+54 9 11 5555-0001', funcion: 'Director de Operaciones', role: 'Sponsor' },
        { id: 2, origen: 'evoluciona', name: 'Emilce Maidana', email: 'emaidana@cliente.com', telefono: null, funcion: 'Analista Funcional', role: 'Referente técnico' }
      ]
    },
    /* En que monedas se puede ver. CLP queda sin tipo de cambio a proposito,
       para poder ver como se comporta el selector cuando falta.

       La fecha es la del 2 de septiembre a proposito: es posterior al periodo
       que se mira por defecto, asi que en vista previa se ve el aviso de
       cotizacion de fuera del periodo, que es la situacion real de DEV. */
    conversion: {
      posible: true,
      moneda_proyecto: 'USD',
      moneda_reporte: verEn,
      cotizacion: '1',
      equivalencia: factor,
      fecha: verEn === 'USD' ? null : FECHA_TC_DEMO,
      motivo: null
    },
    monedas_disponibles: [
      { code: 'ARS', nombre: 'Peso argentino', disponible: true, cotizacion: '0.00071', equivalencia: TC_DEMO['ARS'], fecha: FECHA_TC_DEMO, motivo: null },
      { code: 'EUR', nombre: 'Euro', disponible: true, cotizacion: '1.09', equivalencia: TC_DEMO['EUR'], fecha: FECHA_TC_DEMO, motivo: null },
      { code: 'USD', nombre: 'Dólar', disponible: true, cotizacion: '1', equivalencia: 1, fecha: null, motivo: null },
      {
        code: 'CLP',
        nombre: 'Peso chileno',
        disponible: false,
        cotizacion: null,
        equivalencia: null,
        fecha: null,
        motivo: 'No hay cotización de CLP hasta el 2026-08-31'
      }
    ],
    market_data: {
      total_selling_price: convertir(base.total_selling_price) || '0',
      // Las horas y los porcentajes no cambian con la moneda
      sold_hours: base.sold_hours ?? '0',
      cost_mo_hours: convertir('52'),
      other_costs: convertir('18000'),
      operating_margin: convertir(base.operating_margin) || '0',
      operating_margin_percentage: base.operating_margin_percentage ?? '0',
      /* Los mismos números pero sumando los tratos del CRM, que es de donde
         tienen que salir cuando hay más de una orden de venta. Van **ya
         calculados**: `cost_mo_hours` acá es el total, no el costo por hora,
         y recalcularlo del lado de la pantalla lo multiplicaría de nuevo por
         las horas. */
      por_tratos: {
        tratos: 2,
        total_selling_price: 116809.24,
        sold_hours: 2400,
        price_per_hour: 48.67,
        cost_mo_hours: 56000,
        other_costs: 8000,
        total_costs: 64000,
        operating_margin: 52809.24,
        operating_margin_percentage: 45.21
      }
    },
    /* Los dos primeros los manda ARMUS y no se editan; el tercero se cargó en
       Evoluciona. El gerente viene sin `user_odoo_id` a propósito: es un
       empleado que puede no tener usuario de Odoo. */
    project_state_name: 'En Curso',
    /* Lo que ARMUS deja hacer desde En Curso. No incluye Planificación ni
       Cerrado a propósito: son los dos que la barra tiene que rechazar. */
    estados_disponibles: ['en_pausa', 'replanificacion', 'finalizaso', 'cancelado'],
    tratos: [
      { orden: 'S00087', codigo: '118', nombre: 'Venta inicial' },
      { orden: 'S00099', codigo: '144', nombre: 'Ampliación' }
    ],
    /* El proyecto de demo está en ejecución, así que las fechas van grises y
       el nombre y la descripción no. Es el caso que más se ve. */
    editable: {
      nombre: true,
      descripcion: true,
      fechas: false,
      motivo_fechas: 'Las fechas se editan en Planificación y Replanificación.',
      de_armus: ['empresa', 'tipo_proyecto', 'tipo_producto', 'tipo_servicio', 'region', 'unidad_negocio']
    },
    responsibles: [
      { role_id: 1, role: 'Gerente de Proyecto', origen: 'armus', user_odoo_id: null, name: 'Emilce Maidana', email: 'emaidana@vippinn.com' },
      { role_id: 2, role: 'Responsable de Mercado', origen: 'armus', user_odoo_id: 202, name: 'Matías Salto', email: 'msalto@vippinn.com' },
      { role_id: 3, role: 'Service/Project manager', origen: 'evoluciona', user_odoo_id: 203, name: 'Valentina Merlo', email: 'vmerlo@vippinn.com' }
    ]
  };
}

/* ==========================================================================
   Monitor de carga
   ========================================================================== */

/* ==========================================================================
   Datos sembrados del monitor.

   Todo se deriva de los items: los conteos de cada ejecucion y el tablero por
   periodo se calculan a partir de ellos. Escribirlos por separado ya llevo dos
   veces a que una ejecucion dijera "185 con error" y listara ocho renglones en
   verde.
   ========================================================================== */

const PROYECTOS = [
  ['PRJ-001', 'CER'], ['PRJ-002', 'Trackinn'], ['PRJ-003', 'Monitor'],
  ['PRJ-004', 'Telesoft'], ['PRJ-005', 'Portal Clientes'],
  ['PRJ-006', 'Migración SAP'], ['PRJ-007', 'Mantenimiento Odoo'],
  ['PRJ-008', 'Data Hub']
];

function itemsOk() {
  return PROYECTOS.map(([ref, nombre]) => ({
    entidad: 'proyectos', referencia: ref, nombre,
    status: 'ok', reintentable: true, mensaje: null
  }));
}

/**
 * Una corrida de catálogos, con los volúmenes reales de ARMUS: 251 países, 15
 * tipos de producto, 31 de servicio… Existe para poder probar el filtro y la
 * paginación del detalle, que con diez renglones no se ven.
 */
function itemsCatalogos() {
  const items: any[] = [];

  const agregar = (entidad: string, cuantos: number, desde: number) => {
    for (let i = 0; i < cuantos; i++) {
      items.push({
        entidad,
        referencia: String(desde + i),
        nombre: `${entidad} ${i + 1}`,
        status: 'ok',
        reintentable: false,
        mensaje: null
      });
    }
  };

  agregar('estados', 6, 1);
  agregar('tipo_proyectos', 1, 20);
  agregar('paises', 251, 100);
  agregar('Tipo_productos', 15, 400);
  agregar('tipo_servicios', 31, 500);
  agregar('unidad_negocios', 4, 600);
  agregar('regiones', 2, 700);

  // Los que ARMUS manda sin tipo de producto: se omiten a propósito
  for (let i = 0; i < 38; i++) {
    items.push({
      entidad: 'tipo_servicios',
      referencia: String(160 + i),
      nombre: `Servicio sin producto ${i + 1}`,
      status: 'omitido',
      reintentable: false,
      mensaje: "Falta el campo obligatorio 'tipo_producto_id'"
    });
  }

  return items;
}

/** Cada ejecución, con sus renglones. Los números salen de acá. */
const CORRIDAS: any[] = [
  {
    code: 'EJ-2026-08-C', type: 'manual', source: 'odoo', scope: 'catalogos',
    periodo: '2026-08', fecha: '2026-09-01', inicio: '22:45:10', fin: '22:45:38',
    duracion: '28 seg', usuario: 'Facundo Aguirre', mensaje: null,
    items: itemsCatalogos()
  },
  {
    code: 'EJ-2026-08', type: 'mensual', source: 'odoo', scope: 'projects',
    periodo: '2026-08', fecha: '2026-09-01', inicio: '02:00:01', fin: '02:12:18',
    duracion: '12 min 17 seg', usuario: 'Sistema', mensaje: null,
    items: [
      { entidad: 'proyectos', referencia: 'PRJ-118', nombre: 'Portal Clientes', status: 'error',
        reintentable: true, mensaje: 'El tipo de servicio 84 no existe en el catálogo' },
      { entidad: 'proyectos', referencia: 'PRJ-140', nombre: 'Migración SAP', status: 'error',
        reintentable: true, mensaje: 'Falta el campo obligatorio "codigo"' },
      { entidad: 'proyectos', referencia: 'PRJ-093', nombre: 'Sitio corporativo', status: 'omitido',
        reintentable: false, mensaje: 'La empresa está excluida de Evoluciona (AEROBYTE SAS)' },
      { entidad: 'proyectos', referencia: 'PRJ-101', nombre: 'Campaña Q3', status: 'omitido',
        reintentable: false, mensaje: 'La empresa está excluida de Evoluciona (ONE PAGE AGENCY S.A.S.)' },
      { entidad: 'proyectos', referencia: 'PRJ-077', nombre: 'Data Hub', status: 'omitido',
        reintentable: true, mensaje: 'Llegó sin información de CRM' },
      ...itemsOk()
    ]
  },
  {
    code: 'EJ-2026-08-2', type: 'reproceso', source: 'odoo', scope: 'projects',
    periodo: '2026-08', fecha: '2026-09-02', inicio: '10:14:05', fin: '10:15:22',
    duracion: '1 min 17 seg', usuario: 'Juan Pérez', mensaje: null,
    items: [
      { entidad: 'proyectos', referencia: 'PRJ-118', nombre: 'Portal Clientes',
        status: 'ok', reintentable: true, mensaje: null },
      { entidad: 'proyectos', referencia: 'PRJ-140', nombre: 'Migración SAP',
        status: 'ok', reintentable: true, mensaje: null }
    ]
  },
  {
    code: 'EJ-2026-08-T', type: 'mensual', source: 'trakkinn', scope: 'rates',
    periodo: '2026-08', fecha: '2026-09-01', inicio: '03:00:00', fin: '03:01:12',
    duracion: '1 min 12 seg', usuario: 'Sistema', mensaje: null,
    items: [{ entidad: 'tarifas', referencia: 'T-001', nombre: 'Tarifario vigente',
              status: 'ok', reintentable: true, mensaje: null }]
  },
  {
    /* La que se cayó entera: Odoo no respondió, así que no hay un renglón por
       proyecto sino uno solo con el motivo. */
    code: 'EJ-2026-07', type: 'mensual', source: 'odoo', scope: 'projects',
    periodo: '2026-07', fecha: '2026-08-01', inicio: '02:00:02', fin: '02:08:33',
    duracion: '8 min 31 seg', usuario: 'Sistema',
    mensaje: 'Odoo respondió 503 durante toda la ventana',
    items: [
      { entidad: 'proyectos', referencia: null, nombre: null, status: 'error',
        reintentable: true, mensaje: 'Odoo respondió 503 Service Unavailable' }
    ]
  },
  {
    code: 'EJ-2026-07-T', type: 'mensual', source: 'trakkinn', scope: 'rates',
    periodo: '2026-07', fecha: '2026-08-01', inicio: '03:00:00', fin: '03:01:05',
    duracion: '1 min 5 seg', usuario: 'Sistema', mensaje: null,
    items: [{ entidad: 'tarifas', referencia: 'T-001', nombre: 'Tarifario vigente',
              status: 'ok', reintentable: true, mensaje: null }]
  }
];

// Los meses tranquilos: una corrida por sistema, todas en verde
for (const mes of [6, 5, 4, 3]) {
  const mm = String(mes).padStart(2, '0');
  const siguiente = String(mes + 1).padStart(2, '0');

  CORRIDAS.push(
    { code: `EJ-2026-${mm}`, type: 'mensual', source: 'odoo', scope: 'projects',
      periodo: `2026-${mm}`, fecha: `2026-${siguiente}-01`, inicio: '02:00:01',
      fin: '02:11:40', duracion: '11 min 39 seg', usuario: 'Sistema', mensaje: null,
      items: itemsOk() },

    { code: `EJ-2026-${mm}-T`, type: 'mensual', source: 'trakkinn', scope: 'rates',
      periodo: `2026-${mm}`, fecha: `2026-${siguiente}-01`, inicio: '03:00:00',
      fin: '03:01:05', duracion: '1 min 5 seg', usuario: 'Sistema', mensaje: null,
      items: [{ entidad: 'tarifas', referencia: 'T-001', nombre: 'Tarifario vigente',
                status: 'ok', reintentable: true, mensaje: null }] }
  );
}

/** Los conteos y el estado salen de los renglones, nunca al revés */
function resumirCorrida(c: any) {
  const ok = c.items.filter((i: any) => i.status === 'ok').length;
  const errores = c.items.filter((i: any) => i.status === 'error').length;
  const omitidos = c.items.filter((i: any) => i.status === 'omitido').length;

  const status = errores === 0 && omitidos === 0
    ? 'exitoso'
    : ok === 0 ? 'error' : 'parcial';

  const { items, ...resto } = c;

  return { ...resto, status, ok, errores, omitidos, total: c.items.length };
}

const EJECUCIONES_DEMO = CORRIDAS.map(resumirCorrida);

const ITEMS_DEMO: Record<string, any[]> = Object.fromEntries(
  CORRIDAS.map((c) => [c.code, c.items])
);

/** El estado de un sistema en un mes, calculado desde sus ejecuciones */
function saludDeMes(anio: number, mes: number, sistema: string) {
  const mm = String(mes).padStart(2, '0');

  // Por el período que cierra, no por cuándo corrió
  const suyas = EJECUCIONES_DEMO.filter(
    (e) => e.source === sistema && e.periodo === `${anio}-${mm}`
  );

  if (suyas.length === 0) {
    return { estado: 'sin_datos', corridas: 0, ok: 0, errores: 0, omitidos: 0, ultima: null };
  }

  const estado = suyas.some((e) => e.status === 'error')
    ? 'error'
    : suyas.some((e) => e.status === 'parcial')
      ? 'parcial'
      : 'exitoso';

  return {
    estado,
    corridas: suyas.length,
    ok: suyas.reduce((a, e) => a + e.ok, 0),
    errores: suyas.reduce((a, e) => a + e.errores, 0),
    omitidos: suyas.reduce((a, e) => a + e.omitidos, 0),
    ultima: suyas[0].fecha
  };
}

function saludDemo(anio: number) {
  const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                 'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

  /* Hasta agosto y no hasta septiembre: el mes en curso todavía no cerró.
     Ver la regla del período vigente. */
  const periodos = [];
  for (let m = 8; m >= 1; m--) {
    periodos.push({
      mes: m,
      etiqueta: meses[m - 1],
      sistemas: {
        odoo: saludDeMes(anio, m, 'odoo'),
        trakkinn: saludDeMes(anio, m, 'trakkinn')
      }
    });
  }

  return { anio, sistemas: ['odoo', 'trakkinn'], periodos };
}

export function respuestaMonitor(ruta: string, params?: URLSearchParams): unknown | null {
  /* Lo que sale hacia ARMUS. Uno enviado, uno con error y uno pendiente de un
     circuito apagado: los tres casos que la pantalla dibuja distinto. */
  if (/\/api\/armus-envios\/?$/.test(ruta)) {
    return {
      success: true,
      circuitos: {
        provisiones: { activo: false, endpoint: '/intranet/v1/provisiones' },
        proyecto: { activo: true, endpoint: '/intranet/v1/proyectos' },
        proyecto_estado: { activo: true, endpoint: '/intranet/v1/proyectos' },
        proyecto_responsables: { activo: true, endpoint: '/intranet/v1/proyectos' }
      },
      pendientes: 2,
      data: [
        {
          id: 3, entidad: 'proyecto_estado', entidad_id: 1, accion: 'actualizar',
          referencia: 'SEED01', estado: 'error', intentos: 2,
          ultimo_error: 'Desde "En Curso" no se puede pasar a "Planificación". Se puede ir a: en_pausa, replanificacion, finalizaso, cancelado.',
          enviado_at: null, creado: '2026-09-04T14:12:00-03:00'
        },
        {
          id: 2, entidad: 'provisiones', entidad_id: 8, accion: 'crear',
          referencia: 'SEED01', estado: 'pendiente', intentos: 0,
          ultimo_error: null, enviado_at: null, creado: '2026-09-04T13:40:00-03:00'
        },
        {
          id: 1, entidad: 'proyecto', entidad_id: 1, accion: 'actualizar',
          referencia: 'SEED01', estado: 'enviado', intentos: 1,
          ultimo_error: null, enviado_at: '2026-09-04T13:05:00-03:00', creado: '2026-09-04T13:05:00-03:00'
        }
      ],
      total: 3, pagina: 1, paginas: 1
    };
  }

  if (/\/api\/sync-runs\/por-periodo\/?$/.test(ruta)) {
    return { success: true, data: saludDemo(2026) };
  }

  if (/\/api\/sync-runs\/resumen\/?$/.test(ruta)) {
    return {
      success: true,
      data: {
        anios: [2026, 2025],
        periodo_vigente: '2026-08',
        ultima: EJECUCIONES_DEMO[0],
        corriendo: 0,
        interrumpidas: 1,
        del_mes: 1
      }
    };
  }

  const reprocesar = ruta.match(/\/api\/sync-runs\/([^/]+)\/reprocesar\/?$/);
  if (reprocesar) {
    const items = ITEMS_DEMO[reprocesar[1]] ?? [];
    const refs = items
      .filter((i) => i.status !== 'ok' && i.reintentable && i.referencia)
      .map((i) => i.referencia);

    return { success: true, data: { ejecucion: reprocesar[1], scope: 'projects',
      referencias: refs, cantidad: refs.length, parent_run_id: 1 } };
  }

  const detalle = ruta.match(/\/api\/sync-runs\/([^/]+)\/?$/);
  if (detalle) {
    const ej = EJECUCIONES_DEMO.find((e) => e.code === detalle[1]);
    if (!ej) return null;

    const todos = ITEMS_DEMO[ej.code] ?? [];

    /* Los mismos filtros que aplica el backend. Se reproducen acá porque una
       ejecución de catálogos trae cientos de renglones y sin esto no se puede
       revisar la pantalla en local. */
    const buscar = params?.get('buscar')?.toLowerCase() ?? '';
    const status = params?.get('status') ?? '';
    const entidad = params?.get('entidad') ?? '';

    const filtrar = (lista: any[], excepto: string) =>
      lista.filter(
        (i) =>
          (excepto === 'status' || !status || i.status === status) &&
          (excepto === 'entidad' || !entidad || i.entidad === entidad) &&
          (excepto === 'buscar' ||
            !buscar ||
            i.referencia?.toLowerCase().includes(buscar) ||
            i.nombre?.toLowerCase().includes(buscar) ||
            i.mensaje?.toLowerCase().includes(buscar))
      );

    // Lo que falló, arriba: es lo que se viene a mirar
    const orden: Record<string, number> = { error: 0, omitido: 1, ok: 2 };
    const filtrados = filtrar(todos, '').sort(
      (a, b) => (orden[a.status] ?? 9) - (orden[b.status] ?? 9)
    );

    const porPagina = Number(params?.get('por_pagina') ?? 50);
    const paginas = Math.max(1, Math.ceil(filtrados.length / porPagina));
    const pagina = Math.min(Math.max(1, Number(params?.get('pagina') ?? 1)), paginas);

    return {
      success: true,
      data: {
        ejecucion: ej,
        items: filtrados.slice((pagina - 1) * porPagina, pagina * porPagina),
        opciones: {
          estados: [...new Set(filtrar(todos, 'status').map((i) => i.status))].sort(),
          entidades: [...new Set(filtrar(todos, 'entidad').map((i) => i.entidad))].sort()
        },
        meta: {
          pagina,
          paginas,
          total: filtrados.length,
          por_pagina: porPagina,
          total_sin_filtros: todos.length
        }
      }
    };
  }

  if (/\/api\/sync-runs\/?$/.test(ruta)) {
    let ejecuciones: any[] = EJECUCIONES_DEMO;

    const status = params?.get('status');
    if (status) ejecuciones = ejecuciones.filter((e) => e.status === status);

    const source = params?.get('source');
    if (source) ejecuciones = ejecuciones.filter((e) => e.source === source);

    const scope = params?.get('scope');
    if (scope) ejecuciones = ejecuciones.filter((e) => e.scope === scope);

    // Período: llega desde el tablero de semáforos
    const anio = params?.get('anio');
    const mes = params?.get('mes');

    if (anio && mes) {
      const p = `${anio}-${String(mes).padStart(2, '0')}`;
      ejecuciones = ejecuciones.filter((e) => e.periodo === p);
    } else if (anio) {
      ejecuciones = ejecuciones.filter((e) => e.periodo?.startsWith(anio));
    }

    /* La búsqueda mira el código y también adentro del paquete, igual que el
       backend: es la única forma de probar la pantalla sin servidor. */
    const buscar = params?.get('buscar')?.toLowerCase();

    if (buscar) {
      ejecuciones = ejecuciones
        .map((e) => {
          const items = (ITEMS_DEMO[e.code] ?? []).filter(
            (i) =>
              i.referencia?.toLowerCase().includes(buscar) ||
              i.nombre?.toLowerCase().includes(buscar)
          );

          return { ...e, coincidencias: items };
        })
        .filter(
          (e) => e.code.toLowerCase().includes(buscar) || e.coincidencias.length > 0
        );
    }

    /* Las opciones de cada desplegable: con el resto de los filtros puestos,
       pero sin el propio. Si se aplicara tambien el propio, elegir una opcion
       dejaria fuera de la lista a todas las demas. */
    const conFiltros = (excepto: string) => {
      let base: any[] = EJECUCIONES_DEMO;

      if (excepto !== 'status' && status) base = base.filter((e) => e.status === status);
      if (excepto !== 'source' && source) base = base.filter((e) => e.source === source);
      if (excepto !== 'scope' && scope) base = base.filter((e) => e.scope === scope);

      if (anio && mes) {
        const p = `${anio}-${String(mes).padStart(2, '0')}`;
        base = base.filter((e) => e.periodo === p);
      } else if (anio) {
        base = base.filter((e) => e.periodo?.startsWith(anio));
      }

      return base;
    };

    return {
      success: true,
      data: ejecuciones,
      opciones: {
        estados: [...new Set(conFiltros('status').map((e) => e.status))].sort(),
        origenes: [...new Set(conFiltros('source').map((e) => e.source))].sort(),
        alcances: [...new Set(conFiltros('scope').map((e) => e.scope))].sort()
      },
      meta: { pagina: 1, paginas: 1, total: ejecuciones.length, por_pagina: 10 }
    };
  }

  return null;
}
